(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("dashboardCommon", {
        templateUrl: "app/dashboard/dashboardCommon.component.html",
        controller: ["dashboardResource", "accountDashboardResource", "messageService", "$state", "$scope", DashboardCommonCtrl],
        controllerAs: "vm"
    });
    function DashboardCommonCtrl(dashboardResource, accountDashboardResource, messageService, $state, $scope) {
        var vm = this;
        if ($state.params)
            vm.isReadOnly = $state.params.isReadOnly;
        loadData();
        /////////////////////////////////////////////////////////////////////
        function loadData() {
            if (vm.isReadOnly) {
                dashboardResource.getCommonViewModel({ personSeq: $state.params.personSeq }, function (data) {
                    vm.data = data;
                    vm.loaded = true;
                }, function (error) {
                    messageService.error(error);
                });
            }
            else {
                accountDashboardResource.getCommonViewModel(function (data) {
                    vm.data = data;
                    vm.loaded = true;
                }, function (error) {
                    messageService.error(error);
                });
            }
        }
        ;
        vm.loadMyNotifications = function () {
            if (!vm.isReadOnly)
                $state.go("main.accountNotifications");
        };
        vm.loadMyAccount = function () {
            if (!vm.isReadOnly)
                $state.go("main.myAccount");
        };
        //	$scope.$on("refreshDashboardNotifications", function () {
        //		loadData();
        //	});
    }
}());
